import {applyMiddleware, createStore} from 'redux';
import {createEpicMiddleware} from 'redux-observable';
import {persistStore} from 'redux-persist';
import {rootEpic} from '../rootEpic.js';
import createReducer from '../reducers.js';
import {composeWithDevTools} from 'redux-devtools-extension';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 10 });

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const logger = store => next => action => {
  console.group(action ? action.type : "???");
  console.info('dispatching', action);
  
  // Call the next middleware in the chain or the reducer if there are no more middlewares
  let result = next(action); 
  
  // Log the new state after the action has been processed
  console.log('next state', store.getState());
  console.groupEnd();

  return result;
};
    //   applyMiddleware(logger),

export default function configureStore( initialState ) {
  const store = createStore(
      createReducer(),
      initialState,
      composeEnhancers(
          applyMiddleware(
              createEpicMiddleware(rootEpic),
            // logger
          )
      ));
  store.asyncReducers = {};

  const persistor = persistStore(store);
  return {store, persistor};
}

// Support for code splitting of reducers if all don't need to be loaded
// initially in the app
export function injectAsyncReducer( store, name, asyncReducer ) {
  // Only add in if it doesn't already exist
  if ( typeof(store.asyncReducers[ name ]) === 'undefined' ) {
    store.asyncReducers[ name ] = asyncReducer;
    store.replaceReducer( createReducer( store.asyncReducers ) );
  }
}



// WEBPACK FOOTER //
// ./public/pages/Store.jsx